import { gql } from '@apollo/client';

export default gql`
  query booking($reference: String!) {
    booking(reference: $reference) {
      reference
    }
  }
`;
